(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  connectedCallback() {
    this._header = document.querySelector('.section-header');
    this._isAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
    this._bounds = {};
    this._currentScrollTop = 0;
    this._preventReveal = false;

    this._setHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this._setHeight.bind(this));

    if (this._isAlwaysSticky) this._header.classList.add('shopify-section-header-sticky');

    this._onScrollHandler = this._onScroll.bind(this);
    window.addEventListener('scroll', this._onScrollHandler, { passive: true });
    this._createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScrollHandler);
  }

  _setHeight() {
    document.documentElement.style.setProperty('--header-height', `${this._header.offsetHeight}px`);
  }

  _createObserver() {
    new IntersectionObserver((entries, obs) => {
      this._bounds = entries[0].intersectionRect;
      obs.disconnect();
    }).observe(this._header);
  }

  _onScroll() {
    const scrollTop = window.scrollY;
    if (scrollTop > this._bounds.bottom) {
      this._header.classList.add('scrolled-past-header');
      if (this._isAlwaysSticky) {
        // Always sticky: keep header visible at all times
        requestAnimationFrame(this._reveal.bind(this));
      } else if (scrollTop > this._currentScrollTop) {
        // on-scroll-up: hide when scrolling down
        requestAnimationFrame(this._hide.bind(this));
      } else if (!this._preventReveal) {
        // on-scroll-up: reveal when scrolling up
        requestAnimationFrame(this._reveal.bind(this));
      }
    } else if (scrollTop <= this._bounds.top) {
      this._header.classList.remove('scrolled-past-header');
      if (!this._isAlwaysSticky) requestAnimationFrame(this._reset.bind(this));
    }
    this._currentScrollTop = scrollTop;
  }

  _hide() { this._header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); }
  _reveal() {
    this._header.classList.add('shopify-section-header-sticky');
    this._header.classList.remove('shopify-section-header-hidden', 'animate');
  }
  _reset() { this._header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
}

customElements.define('sticky-header', StickyHeader);

class MobileMenuDrawer {
  constructor() {
    this._drawer = document.getElementById('MobileMenuDrawer');
    this._openBtn = document.querySelector('[data-mobile-menu-open]');
    this._closeBtn = document.getElementById('MobileMenuClose');
    this._overlay = document.getElementById('MobileMenuOverlay');
    if (!this._drawer || !this._openBtn) return;

    this._openBtn.addEventListener('click', this.open.bind(this));
    if (this._closeBtn) this._closeBtn.addEventListener('click', this.close.bind(this));
    if (this._overlay) this._overlay.addEventListener('click', this.close.bind(this));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._isOpen()) this.close();
    });
  }

  _isOpen() {
    return this._drawer.classList.contains('mobile-menu--open');
  }

  open() {
    this._drawer.classList.add('mobile-menu--open');
    this._drawer.setAttribute('aria-hidden', 'false');
    this._openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-menu-open');
    // Focus close button for accessibility
    if (this._closeBtn) setTimeout(() => this._closeBtn.focus(), 50);
  }

  close() {
    this._drawer.classList.remove('mobile-menu--open');
    this._drawer.setAttribute('aria-hidden', 'true');
    this._openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
    this._openBtn.focus();
  }
}

class MegaMenu {
  constructor() {
    this._panel = document.getElementById('SiteMegaMenu');
    this._triggers = document.querySelectorAll('[data-mega-trigger]');
    if (!this._panel || !this._triggers.length) return;

    this._closeTimer = null;

    this._triggers.forEach((trigger) => {
      const li = trigger.closest('.site-header__nav-item--mega');
      if (li) {
        li.addEventListener('mouseenter', this._open.bind(this));
        li.addEventListener('mouseleave', this._scheduleClose.bind(this));
      }
      trigger.addEventListener('click', this._toggle.bind(this));
    });

    this._panel.addEventListener('mouseenter', this._cancelClose.bind(this));
    this._panel.addEventListener('mouseleave', this._scheduleClose.bind(this));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._isOpen()) {
        this._close();
        this._triggers[0] && this._triggers[0].focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this._panel.contains(e.target) && !Array.from(this._triggers).some((t) => t.contains(e.target))) {
        this._close();
      }
    });
  }

  _isOpen() {
    return this._panel.classList.contains('mega-menu--open');
  }

  _open() {
    clearTimeout(this._closeTimer);
    this._panel.classList.add('mega-menu--open');
    this._panel.setAttribute('aria-hidden', 'false');
    this._triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
  }

  _close() {
    clearTimeout(this._closeTimer);
    this._panel.classList.remove('mega-menu--open');
    this._panel.setAttribute('aria-hidden', 'true');
    this._triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
  }

  _scheduleClose() {
    this._closeTimer = setTimeout(this._close.bind(this), 200);
  }

  _cancelClose() {
    clearTimeout(this._closeTimer);
  }

  _toggle() {
    if (this._isOpen()) {
      this._close();
    } else {
      this._open();
    }
  }
}

class HeaderDropdown {
  constructor() {
    this._dropdowns = document.querySelectorAll('.site-header__nav .site-header__dropdown');
    if (!this._dropdowns.length) return;

    this._closeTimer = null;
    this._mq = window.matchMedia('(min-width: 990px)');

    this._dropdowns.forEach((details) => {
      const item = details.closest('.site-header__nav-item');
      if (!item) return;

      item.addEventListener('mouseenter', () => {
        if (!this._mq.matches) return;
        this._cancelClose();
        this._closeAllExcept(details);
        details.open = true;
      });

      item.addEventListener('mouseleave', () => {
        if (!this._mq.matches) return;
        this._scheduleClose(details);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this._closeAll();
    });
  }

  _scheduleClose(details) {
    clearTimeout(this._closeTimer);
    this._closeTimer = setTimeout(() => {
      details.open = false;
    }, 200);
  }

  _cancelClose() {
    clearTimeout(this._closeTimer);
  }

  _closeAllExcept(except) {
    this._dropdowns.forEach((details) => {
      if (details !== except) details.open = false;
    });
  }

  _closeAll() {
    this._dropdowns.forEach((details) => {
      details.open = false;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileMenuDrawer();
  new MegaMenu();
  new HeaderDropdown();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.product-main');
  var form = document.getElementById('ProductForm');
  if (!root || !form) return;

  var variantInput = document.getElementById('ProductVariantId');
  var qtyInput = document.getElementById('ProductQty');
  var addBtn = document.getElementById('ProductAddToCart');
  var mainImg = document.getElementById('ProductMainImage');
  var priceCurrentEl = document.getElementById('ProductPriceCurrent');
  var priceOriginalEl = document.getElementById('ProductPriceOriginal');
  var badgeEl = document.getElementById('ProductDiscountBadge');
  var skuEl = document.getElementById('ProductSKU');
  var skuWrap = document.getElementById('ProductSKUWrap');
  var stockNoticeEl = document.getElementById('ProductStockNotice');
  var weightEl = document.getElementById('ProductWeight');

  var variantsData = [];
  var backorderData = { productBackorder: '', variants: {} };
  var galleryData = { featuredImageId: null, featuredImageSrc: '', featuredImageAlt: '' };
  var weightsData = {};
  try {
    variantsData = JSON.parse(document.getElementById('ProductVariantsJSON').textContent);
  } catch (e) {}
  try {
    backorderData = JSON.parse(document.getElementById('ProductBackorderJSON').textContent);
  } catch (e) {}
  try {
    galleryData = JSON.parse(document.getElementById('ProductGalleryJSON').textContent);
  } catch (e) {}
  try {
    weightsData = JSON.parse(document.getElementById('ProductWeightsJSON').textContent);
  } catch (e) {}

  var formError = form.querySelector('[data-product-form-error]');
  var optionBtns = root.querySelectorAll('.product-main__option-btn');
  var thumbs = root.querySelectorAll('.product-main__thumb');
  var track = document.getElementById('ThumbTrack');
  var productFeaturedImageId = galleryData.featuredImageId;
  var productFeaturedImageSrc = galleryData.featuredImageSrc;
  var productFeaturedImageAlt = galleryData.featuredImageAlt;

  function clearFormError() {
    if (!formError) return;
    formError.textContent = '';
    formError.hidden = true;
  }

  function showFormError(message) {
    if (!formError) return;
    formError.textContent = message;
    formError.hidden = false;
  }

  function setMainImage(src, alt) {
    if (!mainImg || !src) return;
    mainImg.classList.add('product-main__image--fade');
    setTimeout(function () {
      mainImg.src = src;
      mainImg.srcset = '';
      if (alt) mainImg.alt = alt;
      mainImg.classList.remove('product-main__image--fade');
    }, 160);
  }

  function selectThumb(thumb) {
    if (!mainImg || !thumb) return;
    thumbs.forEach(function (t) { t.classList.remove('product-main__thumb--active'); });
    thumb.classList.add('product-main__thumb--active');
    setMainImage(thumb.dataset.imageUrl, thumb.dataset.imageAlt);
    if (track) {
      var trackRect = track.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var offset = thumbRect.left - trackRect.left - (trackRect.width / 2) + (thumbRect.width / 2);
      track.scrollBy({ left: offset, behavior: 'smooth' });
    }
  }

  function findThumbByImageId(imageId) {
    if (!imageId) return null;
    return Array.prototype.find.call(thumbs, function (thumb) {
      return String(thumb.dataset.imageId) === String(imageId);
    }) || null;
  }

  function updateVariantImage(variant) {
    if (!mainImg || !variant) return;

    var featured = variant.featured_image;
    var imageId = featured && featured.id ? featured.id : productFeaturedImageId;
    var thumb = findThumbByImageId(imageId);

    if (thumb) {
      selectThumb(thumb);
      return;
    }

    if (featured && featured.src) {
      setMainImage(featured.src, featured.alt || productFeaturedImageAlt);
      return;
    }

    if (productFeaturedImageSrc) {
      setMainImage(productFeaturedImageSrc, productFeaturedImageAlt);
    }
  }

  /* ── Quantity buttons ── */
  form.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      clearFormError();
      var delta = parseInt(this.dataset.qtyChange);
      var val = Math.max(1, (parseInt(qtyInput.value) || 1) + delta);
      qtyInput.value = val;
    });
  });

  /* ── Variant selection ── */
  function getSelectedOptions() {
    var opts = {};
    root.querySelectorAll('.product-main__option-values').forEach(function (group) {
      var active = group.querySelector('.product-main__option-btn--active');
      if (active) opts[active.dataset.optionIndex] = active.dataset.optionValue;
    });
    return opts;
  }

  function findVariant(selected) {
    return variantsData.find(function (v) {
      return v.options.every(function (opt, i) {
        return String(selected[i]) === String(opt);
      });
    });
  }

  function optionExistsWithSelection(optionIndex, optionValue, selected) {
    return variantsData.some(function (variant) {
      if (String(variant.options[optionIndex]) !== String(optionValue)) return false;
      return Object.keys(selected).every(function (key) {
        var i = Number(key);
        if (i === optionIndex) return true;
        return String(variant.options[i]) === String(selected[key]);
      });
    });
  }

  function updateOptionAvailability() {
    var selected = getSelectedOptions();
    optionBtns.forEach(function (btn) {
      var index = Number(btn.dataset.optionIndex);
      var value = btn.dataset.optionValue;
      var exists = optionExistsWithSelection(index, value, selected);
      var isActive = btn.classList.contains('product-main__option-btn--active');

      btn.classList.toggle('product-main__option-btn--unavailable', !exists);
      btn.setAttribute('aria-disabled', exists ? 'false' : 'true');
      btn.disabled = !exists && !isActive;
    });
  }

  function setInvalidCombinationState() {
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'INDISPONÍVEL';
    }
    if (stockNoticeEl) {
      stockNoticeEl.textContent = 'Combinação indisponível';
      stockNoticeEl.classList.remove('product-main__stock-notice--backorder');
      stockNoticeEl.classList.add('product-main__stock-notice--sold-out');
      stockNoticeEl.hidden = false;
    }
  }

  function formatMoney(cents) {
    var euros = cents / 100;
    return euros % 1 === 0 ? euros + '€' : euros.toFixed(2) + '€';
  }

  function isBackorderMetafield(variant) {
    if (!variant) return false;
    if (backorderData.variants[String(variant.id)] === 'backorder') return true;
    if (backorderData.productBackorder === 'backorder') return true;
    return false;
  }

  function getStockState(variant) {
    if (!variant) return 'none';
    if (isBackorderMetafield(variant)) return 'backorder';
    if (!variant.available) return 'sold-out';
    if (
      variant.inventory_management === 'shopify' &&
      (variant.inventory_quantity || 0) <= 0 &&
      variant.inventory_policy === 'continue'
    ) {
      return 'backorder';
    }
    return 'none';
  }

  function updateStockNotice(variant) {
    if (!stockNoticeEl) return;
    var state = getStockState(variant);
    stockNoticeEl.classList.remove(
      'product-main__stock-notice--backorder',
      'product-main__stock-notice--sold-out'
    );
    if (state === 'backorder') {
      stockNoticeEl.textContent = 'Disponível por encomenda';
      stockNoticeEl.classList.add('product-main__stock-notice--backorder');
      stockNoticeEl.hidden = false;
    } else if (state === 'sold-out') {
      stockNoticeEl.textContent = 'Esgotado';
      stockNoticeEl.classList.add('product-main__stock-notice--sold-out');
      stockNoticeEl.hidden = false;
    } else {
      stockNoticeEl.textContent = '';
      stockNoticeEl.hidden = true;
    }
  }

  function updateVariantUI(variant) {
    if (!variant) {
      setInvalidCombinationState();
      updateOptionAvailability();
      return;
    }

    variantInput.value = variant.id;

    if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price > variant.price) {
      if (priceOriginalEl) { priceOriginalEl.textContent = formatMoney(variant.compare_at_price); priceOriginalEl.style.display = ''; }
      if (badgeEl) {
        var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        badgeEl.textContent = pct + '%';
        badgeEl.style.display = '';
      }
    } else {
      if (priceOriginalEl) priceOriginalEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'COMPRAR' : 'ESGOTADO';
    }

    updateStockNotice(variant);
    updateVariantImage(variant);
    updateOptionAvailability();

    if (weightEl) {
      var weightLabel = weightsData[String(variant.id)] || '';
      weightEl.textContent = weightLabel;
      weightEl.hidden = !weightLabel;
    }

    if (skuEl) {
      skuEl.textContent = variant.sku || '';
      var wrap = skuWrap || skuEl.closest('.product-main__meta');
      if (wrap) wrap.style.display = variant.sku ? '' : 'none';
    }
  }

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.disabled || this.getAttribute('aria-disabled') === 'true') return;
      clearFormError();
      this.closest('.product-main__option-values')
        .querySelectorAll('.product-main__option-btn')
        .forEach(function (b) { b.classList.remove('product-main__option-btn--active'); });
      this.classList.add('product-main__option-btn--active');
      updateVariantUI(findVariant(getSelectedOptions()));
    });
  });

  form.addEventListener('submit', function (event) {
    var variant = findVariant(getSelectedOptions());
    if (!variant) {
      event.preventDefault();
      setInvalidCombinationState();
      showFormError('Esta combinação de opções não está disponível.');
      return;
    }
    variantInput.value = variant.id;
  });

  var initialVariant = variantsData.find(function (v) {
    return String(v.id) === String(variantInput.value);
  });
  if (initialVariant) {
    updateStockNotice(initialVariant);
  }
  updateOptionAvailability();

  /* ── Gallery thumbnails ── */
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      selectThumb(this);
    });
  });

  if (track && thumbs.length > 1) {
    root.querySelectorAll('.product-main__thumb-arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var activeIndex = Array.prototype.findIndex.call(thumbs, function (t) {
          return t.classList.contains('product-main__thumb--active');
        });
        if (activeIndex === -1) activeIndex = 0;
        var dir = this.classList.contains('product-main__thumb-arrow--next') ? 1 : -1;
        var nextIndex = (activeIndex + dir + thumbs.length) % thumbs.length;
        selectThumb(thumbs[nextIndex]);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var container = document.getElementById('ProductRecommendations');
  if (!container || !container.dataset.url) return;

  fetch(container.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('#ProductRecommendations');
      // Only replace if the API returned actual product cards
      if (inner && inner.querySelector('.product-recs__card')) {
        container.innerHTML = inner.innerHTML;
      }
      // Otherwise keep the fallback content rendered server-side
    })
    .catch(function () {});
})();

  } catch(e) { console.error(e); }
})();
})();
